import Breadcrumbs from './Breadcrumbs.vue'
import BreadcrumbsItem from './BreadcrumbsItem.vue'

export default {
  Breadcrumbs,
  BreadcrumbsItem
}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/index.js